module.exports = __webpack_public_path__ + "img/hnl_big.46d70aaf.png";